import { PurchaseFormValuesKeys } from "../Purchase/types";
import { costText } from "../../constants";

export const confirmText =
  "Ви дійсно хочете деактивувати цей платіж?\n" +
  "Після деактивації скасувати операцію неможливо.";

export const deactivatePaymentText = "Закрыть доступ";

export enum ColumnsIdEnum {
  PaymentDateId = "paymentDate",
  PaymentTypeId = "paymentType",
  ProductIdId = "productId",
  PriceId = "price",
  IsActivatedId = "isActivated",
  ChangeStatusId = "changeStatus",
  ContentNameId = "contentName",
}

export const rowsPerPageOptions = [10, 25, 100];

export const getStatusText = (isActive: boolean) =>
  isActive ? "Activated" : "Deactivated";

interface Column {
  id:
    | PurchaseFormValuesKeys
    | ColumnsIdEnum.IsActivatedId
    | ColumnsIdEnum.ChangeStatusId
    | ColumnsIdEnum.ContentNameId;
  label: string;
}
export const columns: readonly Column[] = [
  { id: ColumnsIdEnum.ProductIdId, label: "ID товару" },
  { id: ColumnsIdEnum.ContentNameId, label: "Назва контенту" },
  { id: ColumnsIdEnum.PaymentDateId, label: "Дата платежу" },
  { id: ColumnsIdEnum.PaymentTypeId, label: "Тип оплати" },
  { id: ColumnsIdEnum.PriceId, label: costText },
  { id: ColumnsIdEnum.IsActivatedId, label: "Статус" },
  { id: ColumnsIdEnum.ChangeStatusId, label: "" },
];
